import { render, staticRenderFns } from "./UserAuthorizationByUserCallContent.vue?vue&type=template&id=3398af01&"
import script from "./UserAuthorizationByUserCallContent.vue?vue&type=script&lang=js&"
export * from "./UserAuthorizationByUserCallContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3398af01')) {
      api.createRecord('3398af01', component.options)
    } else {
      api.reload('3398af01', component.options)
    }
    module.hot.accept("./UserAuthorizationByUserCallContent.vue?vue&type=template&id=3398af01&", function () {
      api.rerender('3398af01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/UserAuthorization/components/common/UserAuthorizationByUserCallContent.vue"
export default component.exports